export default __webpack_public_path__ + "static/media/Banner2.fff18c7b.png";